module.exports = __webpack_public_path__ + "img/fullstack.c490a662.png";